import Rules from '../../types/Rules';

class TaflRules extends Rules {
  kingIsArmed: boolean;

  attackerCountToCapture: number;

  shieldWalls: boolean;

  exitForts: boolean;

  edgeEscape: boolean;

  static copenhagen = {
    kingIsArmed: true,
    attackerCountToCapture: 4,
    shieldWalls: true,
    exitForts: true,
    edgeEscape: false,
  }
}

export default TaflRules;
